// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fltt-match-banner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin: 0 0 12px;
  padding: 12px 14px;
  border-radius: 12px;
  background: color-mix(in srgb, var(--brand-primary, #0877bc) 12%, white);
  border: 1px solid color-mix(in srgb, var(--brand-primary, #0877bc) 35%, transparent);
}

.fltt-match-banner__text {
  margin: 0;
  font-size: 0.95rem;
}

.fltt-match-banner__button {
  border: 0;
  border-radius: 10px;
  padding: 8px 12px;
  font-weight: 650;
  cursor: pointer;
  color: white;
  background: var(--brand-primary, #0877bc);
}
`, "",{"version":3,"sources":["webpack://./src/components/AdminLayout/FlttMatchProposalDialog.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,wEAAwE;EACxE,oFAAoF;AACtF;;AAEA;EACE,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,yCAAyC;AAC3C","sourcesContent":[".fltt-match-banner {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin: 0 0 12px;\n  padding: 12px 14px;\n  border-radius: 12px;\n  background: color-mix(in srgb, var(--brand-primary, #0877bc) 12%, white);\n  border: 1px solid color-mix(in srgb, var(--brand-primary, #0877bc) 35%, transparent);\n}\n\n.fltt-match-banner__text {\n  margin: 0;\n  font-size: 0.95rem;\n}\n\n.fltt-match-banner__button {\n  border: 0;\n  border-radius: 10px;\n  padding: 8px 12px;\n  font-weight: 650;\n  cursor: pointer;\n  color: white;\n  background: var(--brand-primary, #0877bc);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
